import { useTranslation } from "react-i18next";
import { TUseSearchProductPageResponse } from "../../hooks/useSearchProductPage";
import { UiDropdown } from "../dropdown/UiDropdown";
import { icArrowDown2 } from "../image/image-src";
const sortByOptions = [
  "Recommended",
  "Cheapest",
  "Recently hot",
  "Kid-friendly",
];

export const CommonSortBtn = (jj: TUseSearchProductPageResponse) => {
  const { t } = useTranslation();
  return (
    <div className="group relative">
      <button className="relative flex items-center gap-[0.5625rem] border-b border-[#83929D] after:absolute after:-right-2 after:top-4 after:h-4 after:w-full after:content-['']">
        <p className="text-[0.875rem] font-normal leading-[1.25rem] text-[#232323]">
          {jj.search.commonSort === "" ? t("Sort") : t(jj.search.commonSort)}
        </p>
        <img
          className="h-[0.8125rem] w-[0.8125rem]"
          src={icArrowDown2}
          alt=""
        />
      </button>
      <UiDropdown>
        <ul>
          {sortByOptions.map((category) => (
            <li
              key={category}
              className={`h-12 cursor-pointer content-center p-3 transition-all hover:bg-primary/30 ${
                category === jj.search.commonSort
                  ? "bg-primary hover:!bg-primary"
                  : ""
              }`}
              onClick={() => jj.onChooseCommonSort(category)}
            >
              <button type="button">{t(category)}</button>
            </li>
          ))}
        </ul>
      </UiDropdown>
    </div>
  );
};
